import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import client_lookups from '@/assets/json/clientLookups.json'
import axiosInstance from '@/services'

const initForm = async () => {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const { serviceTransactionId } = globalStore.startedService
  formStore.extraMap = {
    ...formStore.extraMap,
    showEstablishmentDetails: false,
    showApplyByNomination: false,
    showProffessionNote: false,
    showLocalAddressDetails: false,
    serviceTransactionId
  }
}

const initData = () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const {
    ServiceTransactions: {
      residenceForResidentFamilyWorkingInPublicSector,
      ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
      visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores,
      visaForUniversityGraduatesInsideUAE
    },
    familyInvestorServices: { issueVisa },
    gccNationalityId: { uae }
  } = client_lookups
  if (
    [
      residenceForResidentFamilyWorkingInPublicSector,
      ResidenceForResidentFamilyWorkingInPrivertSectorOrFreezone,
      visaForResidentWorkingForUaeCitizenOrGccCitizenSponsores,
      issueVisa
    ].includes(+serviceTransactionId)
  ) {
    formStore.draft.request = {
      ...formStore.draft.request,
      sponsorTypeId: 4,
      sponsorTypeCode: 3
    }
  }
  if (serviceTransactionId == visaForUniversityGraduatesInsideUAE) {
    formStore.draft.request.educationLevelCountryId = uae
  }
}
const showProfessionsNote = async () => {
  const formStore = useFormStore()
  const { serviceTransactionId } = formStore.extraMap
  const response = await axiosInstance.get(
    `/api/individual/chickIsFamilyMember/${serviceTransactionId}`
  )
  if (!response) return
  formStore.extraMap.showProffessionNote = result
}
export default async function () {
  try {
    await initForm()
    await initData()
    await showProfessionsNote()
  } catch (error) {
    console.error('useTypingCenterVisaPreload', error)
  }
}
